import Page from './common/page';

class Cookies {
    constructor() {
        this.$el = $('.cookies-container');
        this.ui = {
            $allow: $('.cookies-container__button', this.$el),
        };

        this.state = {
            c:  window.localStorage.getItem('allowCookies'),
        };


        if(this.state.c === null){
            this.$el.addClass('cookies-container_show')
        }

        this.ui.$allow.on('click', this.Allow.bind(this))

    }

    Allow(){
        window.localStorage.setItem('allowCookies', 'true');
        this.$el.removeClass('cookies-container_show');
    }
}

class CookiesForPages extends Page {
    init() {
        this.cookies = new Cookies;
    }
}

export default CookiesForPages;
